export default ($api) => ({
  thuVienVideo: (data) => {
    return $api.get(`media-page`, { params: data })
  },
  thuVienAnh: (data) => {
    return $api.get(`galleries-page`, { params: data })
  },
})
